import { StoreState } from "../../../store/store.interface";

export const getOrder = (state: StoreState) =>
    state.orderCompletionState.data;

export const getOrderStatus = (state: StoreState) =>
    state.orderCompletionState.status;

export const getError = (state: StoreState) =>
    state.orderCompletionState.error;

export const getOrderId = (state: StoreState) =>
    state.orderCompletionState.data?.id;

export const getOrderItems = (state: StoreState) =>
    state.orderCompletionState.data?.orderItems;

export const getOrderApplicationOrderCompletion = (state: StoreState) =>
    state.orderCompletionState.data?.orderItems?.[0]?.productMetaData?.application;

export const getOrderProductMetadata = (state: StoreState) =>
state.orderCompletionState.data?.orderItems?.[0]?.productMetaData!;

export const isSampleOrder = (state: StoreState) =>
    state.orderCompletionState.data?.isSampleOrder;
